import React from 'react'
import PropTypes from 'prop-types'
import { IconFAWrapper } from './IconFAWrapper'

export const IconFAMessage = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconFAWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg
        aria-hidden='true'
        focusable='false'
        data-prefix='far'
        data-icon='message'
        role='img'
        viewBox="0 0 18 18"
        >
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          d="M7.3125 14.625C7.3125 13.6934 6.55664 12.9375 5.625 12.9375H2.25C1.94062 12.9375 1.6875 12.6844 1.6875 12.375V2.25C1.6875 1.94062 1.94062 1.6875 2.25 1.6875H15.75C16.0594 1.6875 16.3125 1.94062 16.3125 2.25V12.375C16.3125 12.6844 16.0594 12.9375 15.75 12.9375H10.8738C10.5082 12.9375 10.1531 13.057 9.86133 13.275L7.3125 15.1875V14.625ZM7.30547 17.3039L7.3125 17.2969L10.8738 14.625H15.75C16.991 14.625 18 13.616 18 12.375V2.25C18 1.00898 16.991 0 15.75 0H2.25C1.00898 0 0 1.00898 0 2.25V12.375C0 13.616 1.00898 14.625 2.25 14.625H3.9375H5.625V16.3125V16.4531V16.4637V16.6887V17.4375C5.625 17.652 5.74453 17.8453 5.93438 17.9402C6.12422 18.0352 6.35273 18.0141 6.525 17.8875L7.12617 17.4375L7.30547 17.3039ZM5.34375 5.0625C4.87617 5.0625 4.5 5.43867 4.5 5.90625C4.5 6.37383 4.87617 6.75 5.34375 6.75H12.6562C13.1238 6.75 13.5 6.37383 13.5 5.90625C13.5 5.43867 13.1238 5.0625 12.6562 5.0625H5.34375ZM5.34375 8.4375C4.87617 8.4375 4.5 8.81367 4.5 9.28125C4.5 9.74883 4.87617 10.125 5.34375 10.125H9.28125C9.74883 10.125 10.125 9.74883 10.125 9.28125C10.125 8.81367 9.74883 8.4375 9.28125 8.4375H5.34375Z"
        />
      </svg>
    </IconFAWrapper>
  )
}

IconFAMessage.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}

